// @ts-check
/**
 * @typedef {import('./CardStrategy').CardStrategy} CardStrategy
 */

/**
 * Stripe card strategy.
 * @function StripeCardStrategy
 * @returns {CardStrategy}
 */
const StripeStrategy = () => {
  /**
   * Create a payload for Stripe.
   *
   * Only wraps the ConfirmationToken. The card data (brand, expiration, masked number, country)
   * and the cardholder name (`card_holder_name`) travel in `cardValues`, already in backend
   * format, and are spread into the payload by the action.
   * @param {Object} cardInfo - The card parameters
   * @param {Object} stripeCardParams - The Stripe card parameters
   * @param {string} stripeCardParams.stripeConfirmationToken - The Stripe ConfirmationToken ID.
   * @returns {Promise<Object>} The payload
   */
  const createPayload = async (cardInfo, { stripeConfirmationToken }) => {
    if (!stripeConfirmationToken) {
      throw new Error('Missing Stripe confirmation token');
    }
    return {
      credit_card_tokens: {
        stripe_confirmation_token: stripeConfirmationToken,
      },
      credit_card_token: stripeConfirmationToken,
    };
  };

  return { createPayload };
};

const stripeStrategy = StripeStrategy();

export default stripeStrategy;
